import { searchCommonConfig } from './common'

export const searchConfig = {
  ...searchCommonConfig,
  colors: {
    inputBg: 'rgba(255, 255, 255, 0.06)',
    startReadingBg: 'linear-gradient(90deg, #A66BFF 0%, #8E47FF 100%)',
    isLight: true,
    cardPadding: '0',
    cardBorder: 'none',
    cardBg: 'transparent',
  },
}
